import { Directive, Input, ElementRef, AfterViewInit, EventEmitter, Output, OnDestroy } from '@angular/core';
import { fromEvent ,  Observable ,  Subject } from 'rxjs';
import { map, pairwise, filter, debounceTime, takeUntil } from 'rxjs/operators';
import { ScrollPosition } from '../models/scrolling';

const DEFAULT_SCROLL_POSITION: ScrollPosition = { sH: 0, sT: 0, cH: 0 };

@Directive({
  selector: '[appInfiniteScroller]'
})
export class InfiniteScrollerDirective implements AfterViewInit, OnDestroy {


  private scrollEvent$: Observable<ScrollPosition>;
  private ngUnsubscribe: Subject<any> = new Subject();
  @Output() public scrolledDown: EventEmitter<void> = new EventEmitter();
  @Input() public scrollPercent = 70;

  constructor(private elm: ElementRef) { }

  ngAfterViewInit(): void {
    this.registerScrollEvent();
    this.streamScrollEvents();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private registerScrollEvent() {
    this.scrollEvent$ = fromEvent(this.elm.nativeElement, 'scroll');
  }

  private streamScrollEvents() {
    this.scrollEvent$.pipe(
      takeUntil(this.ngUnsubscribe),
      map((e: any): ScrollPosition => ({
        sH: e.target.scrollHeight,
        sT: e.target.scrollTop,
        cH: e.target.clientHeight
      })),
      pairwise(),
      filter((positions) => this.isUserScrollingDown(positions) && this.isScrollExpectedPercent(positions[1])),
      // debounceTime(500)
    )
      .subscribe(() => {
        this.scrolledDown.next();
      });
  }

  private isUserScrollingDown(positions: ScrollPosition[]) {
    return positions[0].sT < positions[1].sT;
  }

  private isScrollExpectedPercent(position: ScrollPosition) {
    return ((position.sT + position.cH) / position.sH) > (this.scrollPercent / 100);
  }

}
